import React from 'react';
import { Link } from 'react-router-dom';
import projects from '../data/projects';
import './ProjectsPage.css';

const ProjectsPage = () => {
  const featured = projects
    .filter((p) => p.featured)
    .sort((a, b) => a.order - b.order);
  const earlierWork = projects
    .filter((p) => !p.featured)
    .sort((a, b) => a.order - b.order);

  return (
    <section className="projects-page">
      <h1>Projects</h1>
      <hr className="projects-divider" />
      <p className="projects-intro">
        Pipelines, data models, and analytics systems I've built to turn messy operational and
        business data into decision-ready datasets.
      </p>

      <div className="projects-grid featured-grid">
        {featured.map((project) => (
          <Link to={project.links.detailRoute} className="project-card featured-card" key={project.slug}>
            <h3 className="project-card-title">{project.title}</h3>
            <p className="project-card-description">{project.cardDescription}</p>
            <span className="project-card-cta">View case study &rarr;</span>
          </Link>
        ))}
      </div>

      {earlierWork.length > 0 && (
        <>
          <h2 className="earlier-work-heading">Earlier Analytics &amp; Measurement Work</h2>
          <div className="projects-grid earlier-grid">
            {earlierWork.map((project) => (
              <Link to={project.links.detailRoute} className="project-card earlier-card" key={project.slug}>
                <h3 className="project-card-title">{project.title}</h3>
                <p className="project-card-description">{project.cardDescription}</p>
                <span className="project-card-cta">View case study &rarr;</span>
              </Link>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default ProjectsPage;
